import React from "react";

function DeFiService() {
  return (
    <>
      <div
        className="about-style-three-area default-padding bg-gray bg-cover"
        style={{ background: "url(assets/img/shape/banner-16.html)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h4 className="sub-title">AI writing assistant</h4>
              <h2 className="title split-text-right split-text-in-right">
                DeFi Wallet Development Service
              </h2>
              <p>
                At Xeer Technology, we provide cutting-edge DeFi Wallet
                Development Services designed to empower users with secure,
                user-friendly, and feature-rich wallets that seamlessly
                integrate with the decentralized finance ecosystem. Our team of
                experts creates customized wallet solutions that enable users to
                store, manage, and interact with their digital assets across
                multiple DeFi platforms.
              </p>
              <p>
                With Xeer Technology’s DeFi Wallet Development Service, you can
                provide your users with a secure, scalable, and feature-rich
                wallet that enhances their DeFi experience. Whether you’re an
                individual or a business, we offer tailor-made solutions to meet
                your specific needs. Contact us today to start building your
                custom DeFi wallet solution.
              </p>
              <a className="btn btn-style-one" href="#">
                Know more
              </a>
            </div>
            <div className="col-lg-6">
              <div className="about-style-three-thumb">
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/dashboard-4.jpg"
                  alt="Image Not Found"
                />
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/1.gif"
                  alt="Image Not Found"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DeFiService;
